function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import defaults from '../defaults';

var connectDevTools = function connectDevTools(storeState, config) {
  var devTools = window.__REDUX_DEVTOOLS_EXTENSION__.connect(_objectSpread({
    name: "Store ".concat(storeState.key),
    serialize: true
  }, config));

  devTools.init(storeState.getState());
  devTools.subscribe(function (message) {
    if (message.type === 'DISPATCH') {
      switch (message.payload.type) {
        case 'RESET':
          storeState.resetState();
          devTools.init(storeState.getState());
          return;

        case 'COMMIT':
          devTools.init(storeState.getState());
          return;

        case 'ROLLBACK':
          storeState.setState(JSON.parse(message.state));
          devTools.init(storeState.getState());
          return;

        case 'JUMP_TO_STATE':
        case 'JUMP_TO_ACTION':
          storeState.setState(JSON.parse(message.state));
          return;
      }
    } else if (message.type === 'ACTION') {
      var action = JSON.parse(message.payload);
      storeState.setState(action.payload);
    }
  });
  return devTools;
};

var withDevtools = function withDevtools(createStoreState) {
  return function () {
    var storeState = createStoreState.apply(void 0, arguments);

    if (defaults.devtools && window && window.__REDUX_DEVTOOLS_EXTENSION__) {
      var origMutator = storeState.mutator;
      var devTools;

      var devtoolMutator = function devtoolMutator(arg) {
        var result = origMutator(arg);

        try {
          if (!devTools) {
            var config = typeof defaults.devtools === 'function' ? defaults.devtools(storeState) : {};
            devTools = connectDevTools(storeState, config);
          }

          devTools.send({
            type: storeState.mutator.actionName,
            payload: arg
          }, storeState.getState(), {}, storeState.key);
        } catch (err) {
          /* ignore devtools errors */
        }

        return result;
      };

      storeState.mutator = devtoolMutator;
    }

    return storeState;
  };
};

export default withDevtools;